import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CandidateModel, UserJobsEntityModel } from 'app/interfaces/candidate.model';
import { JobOffersService } from 'app/services';

@Component({
  selector: 'app-job-offers-section',
  templateUrl: './job-offers-section.component.html',
  styleUrls: ['./job-offers-section.component.scss']
})
export class JobOffersSectionComponent implements OnInit {
  @Input('jobOffers') private jobOffersInput: UserJobsEntityModel[] = null;
  @Input('candidate') private candidateInput: CandidateModel = null;
  @Input('specificJobOffer') specificJobOffer: number = null;
  @Input('isExternal') isExternal: boolean = false;
  @Input() current: number = null;

  // @Output() changeProcessStatus: EventEmitter<any> = new EventEmitter<any>();

  public jobOffers: UserJobsEntityModel[] = null;
  public candidate: CandidateModel = null;
  public models: {[key: number]: any} = {};

  constructor(
    private jobOfferService: JobOffersService
  ) { }

  ngOnInit() {
    this.jobOffers = this.jobOffersInput;
    this.candidate = this.candidateInput;
    this.jobOffers.forEach(ele => {
      this.models[ele.id] = {
        comments: ele.comment,
        applications_id: ele.id
      }
    });
    // console.log(this.models);
  }

  public async changeProcessStatus(j: UserJobsEntityModel, ps: string) {
    if (j.process_status === ps) {
      ps = 'new';
    }
    const result = await this.jobOfferService.changeApplicationProcessStatus(j.id, ps);
    j.process_status = result['process_status'];
    // this.sessionService.remove('curricula');
  }

  openVideo(video?) {
    const file = video;
    window.open(file, 'targetWindow',
      'toolbar=no, location=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=400, height=600, left=200, top=100');
  }
}
